// extracted by mini-css-extract-plugin
module.exports = {"hr":"BundlePricingPageSegment-Hr-module--hr--3ur0R"};